import { h, Component } from 'preact'
import { AppBar } from 'react-toolbox/lib/app_bar'
import UserMenu from './../userMenu/UserMenu'

export default class Header extends Component {
  render({ onLeftIconClick }) {
    return (
      <AppBar
        title="fiday"
        leftIcon="menu"
        //rightIcon="face"
        onLeftIconClick={onLeftIconClick}>
        <UserMenu />
      </AppBar>
    )
  }
}



// WEBPACK FOOTER //
// ./components/header/index.js